module.exports = __webpack_public_path__ + "static/img/Frame_06.fdbb220c.svg";